import classNames from "classnames";
import styles from "./index.module.scss";
import TooltipButton from "components/common/Tooltip/TooltipButton";
import { RadixTooltip } from "components/common/Tooltip/RadixTooltip";

const SummaryStatistic = ({ value, label, content = "Estimated proportion of population living in modern slavery out of 1000." }) => {
  const renderScale = () => {
    switch (label) {
      case "Prevalence":
        return "Per 1,000 people";
      case "Vulnerability":
        return "Out of 100";
      case "Gov Response":
        return "Out of 100";
      default:
        return null;
    }
  };

  return (
    <div aria-label={`${label}: ${value}`} className={classNames(styles["summary-statistic"])}>
      <p className={styles["summary-statistic-label"]}>
        <span>{label}</span>
        <span className={styles["summary-statistic-scale"]}>{renderScale()}</span>
      </p>
      <strong className={styles["summary-statistic-value"]}>{value}</strong>
      <div className="absolute md:bottom-2 md:right-4 bottom-1 right-2">
        <RadixTooltip content={content} Trigger={TooltipButton} />
      </div>
    </div>
  );
};

export default SummaryStatistic;
